import database from './database'  //
import btntxt from './btntxt'
import labels from './labels'
import tbhead from './tbhead'
import langs from './langs'
import timebracket from './timebracket'
import liitools from './liitools'
import judinfobox from './judinfobox'
import about from './para/about'
import donors from './para/donors'
import error from './para/error'
import feedback from './para/feedback'
import home from './para/home'
import legal from './para/legal'
import liis from './para/liis'
import operators from './para/operators'
import tour from './para/tour'
import synopsis from './synopsis'
import search from './search'
import sponsors from './sponsors'
import news from './para/news'

export default {
  database,
  btntxt,
  labels,
  tbhead,
  langs,
  timebracket,
  liitools,
  judinfobox,
  about,
  donors,
  error,
  feedback,
  home,
  legal,
  liis,
  operators,
  tour,
  synopsis,
  search,
  sponsors,
  news,
}